const BusinessGetter = {
    businessStates: (state) => state.businessStates,
    businesses: state => state.businesses,
    business: state => state.business
};

export default BusinessGetter;